import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "services/common"

interface CancelBookingExtensionResponse extends AxiosResponse {
  data: {
    data: boolean
    message: string
    apiStatus: ApiStatus
  }
}

export interface CancelBookingExtensionRequest
  extends Partial<AxiosRequestConfig> {
  bookingNumber: string
}

export function cancelBookingExtensionApi(
  { bookingNumber, ...config }: CancelBookingExtensionRequest,
  axiosInstance: AxiosInstance,
): Promise<CancelBookingExtensionResponse> {
  return axiosInstance({
    method: "post",
    url: `/admin/booking/extension/cancel?bookingNumber=${bookingNumber}`,
    ...config,
  }) as Promise<CancelBookingExtensionResponse>
}
